import React from "react";

import { useNavigate } from "react-router-dom";

import { GoogleLogin } from "@react-oauth/google";
import shareVideo from "../assets/scrollvideo.mp4";

import { FcGoogle } from "react-icons/fc";
import { jwtDecode } from "jwt-decode";
import { client } from "../client";

export default function Login() {
  const navigate = useNavigate();

  const responseGoogle = (response) => {
    const decoded = jwtDecode(response.credential);
   
    localStorage.setItem("user", JSON.stringify(decoded));
    const { name, jti, picture } = decoded;

    const doc = {
      _id: jti,
      _type: "user",
      userName: name,
      image: picture,
    };

    client.createIfNotExists(doc).then(() => {
      // Use the navigate function instead of Navigate component
      navigate('/', { replace: true });
    });

    // Do something with the 'doc' object if needed
  };

  return (
    <>
      <div className="flex justify-start items-center flex-col h-screen">
        <div className="relative w-full h-full">
          <video
            src={shareVideo}
            type="video/mp4"
            loop
            controls={false}
            autoPlay
            muted
            className="w-full h-full object-cover"
          />
          <div className="absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0 bg-blackOverlay">
            <div className="p-5">
              <img src={""} width="130px" alt="logo" />
            </div>

            <div className="shadow-2xl">
              <GoogleLogin
                render={(renderProps) => (
                  <button
                    type="button"
                    className="bg-mainColor"
                    onClick={renderProps.onClick}
                  >
                    <FcGoogle className="mr-4" />
                    Sign in With Google
                  </button>
                )}
                onSuccess={responseGoogle}
                onFailure={responseGoogle}
              />
              {/* <GoogleLogin onSuccess={responseGoogle}  /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
